/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview TODO
 */
/* global createjs */
(function($g, createjs, Modernizr, document, Math) {
    "use strict";
    var Tween = createjs.Tween;
    var Ease = createjs.Ease;
    var Shape = createjs.Shape;
    var CenterBtn = $g.CenterBtn;

    var BAR_GAP = 10;
    var BAR_HEIGHT = 1;
    var ACTIF_COLOR = "#616161";
    var INACTIF_COLOR = "#3E3D40";
    var LOADED_COLOR = "#9b9b9b";

    function BottomBar(slideshow, mPlayer) {
        var me = this;
        var stage = me.stage;
        var parent = me.parent;
        var bg = me.bg;
        var right = me.right;
        var btnFullscreen = right.btnFullscreen;
        var btnReduire = right.btnReduire;
        var btnSoundOn = right.btnSoundOn;
        var btnSoundOff = right.btnSoundOff;
        var btnPointeur = me.btnPointeur;
        var centerBtn = me.centerBtn;
        var barre;
        var eFullScreen=false;

        var rightBounds = right.nominalBounds;

        this.show = function(after) {
            parent.addChild(me);
            Tween.get(me)
                    .to({alpha: 1}, 750, Ease.quadOut)
                    .call(after);

        };

        this.hide = function(after) {
            Tween.get(me)
                    .to({alpha: 0}, 750, Ease.quadIn)
                    .call(function() {
                        parent.removeChild(me);
                        after();
                    });
        };

        this.update = function(size) {
            var d = slideshow.duration;
            var t = slideshow.total;
            var p = slideshow.position;
            var pctl = (d>0?(slideshow.loadedDuration/d):0);
            var pcta = ((d>0)?(p/d):0);

            bg.scaleX = size.width/415;
            right.x = size.width;
            var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
            //var fullscreenEnabled = document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled;
            btnFullscreen.visible = !fullscreenElement;
            btnReduire.visible = fullscreenElement;
            var barWidth = size.width - barre.x -BAR_GAP*2 - rightBounds.width;
            barre.scaleX = barWidth;
            var gr = barre.graphics;
            gr
                .c()
                .f(ACTIF_COLOR)
                .r(0,0,pcta,BAR_HEIGHT)
                .ef()

                .f(LOADED_COLOR)
                .r(pcta,0,pctl-pcta,BAR_HEIGHT)
                .ef()

                .f(INACTIF_COLOR)
                .r(pctl,0,1-pctl,BAR_HEIGHT);

            btnPointeur.x = pcta*barWidth+barre.x;
            var playing = mPlayer?mPlayer.muted:true;
            btnSoundOn.visible = !playing;
            btnSoundOff.visible = playing;
            centerBtn.update();
        };

        function exitFullscreen() {
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        }

        function drag(e) {
            var pt = barre.globalToLocal(e.stageX, e.stageY);
            //$g.log(pt.x);
            var p = Math.min(1, Math.max(0, pt.x));
            var d = slideshow.duration;
            slideshow.position = p*d;
        }

        function stopDrag(e) {
            drag(e);
            stage.removeEventListener("stagemousemove", drag);
            stage.removeEventListener("stagemouseup", stopDrag);
            stage.removeEventListener("mouseleave", stopDrag);
            slideshow.dragging=false;
        }

        function startDrag(e) {
            slideshow.dragging=true;
            drag(e);
            stage=me.stage;
            stage.addEventListener("stagemousemove", drag);
            stage.addEventListener("stagemouseup", stopDrag);
            stage.addEventListener("mouseleave", stopDrag);
        }

        function init() {
            var canvas = document.querySelector(".wrapslideshow");
            var pbounds = btnPointeur.nominalBounds;
            parent.removeChild(me);
            barre = new Shape();
            me.addChildAt(barre, 1);
            //barre.y = -me.nominalBounds.height * 0.5;
            barre.y = btnPointeur.y - BAR_HEIGHT*0.5;
            barre.x = 30 + BAR_GAP;
            barre.setRectHitArea(0,-pbounds.height*0.5,1,pbounds.height);
            barre.on("mousedown", startDrag);

            btnFullscreen.setRectHitArea(-3,-5,15+10,13+10);
            btnReduire.setRectHitArea(-3,-5,15+10,13+10);
            var fullScreen = Modernizr.prefixed('requestFullscreen', canvas)||Modernizr.prefixed('requestFullScreen', canvas);
            var b = bowser;
            var mobile = b.tablet || b.mobile;
            //Vérification de la compatibilité avec fullscreen
            //Plusieurs mobile rapportent à tord qu'ils supportent le fullscreen
            eFullScreen = fullScreen && Modernizr.fullscreen && !mobile;
            if (eFullScreen) {
                btnFullscreen.on("click", function() {
                    fullScreen(Element.ALLOW_KEYBOARD_INPUT);
                });
                btnReduire.on("click", function() {
                    exitFullscreen();
                });
            } else {
                btnFullscreen.parent.removeChild(btnFullscreen);
                btnReduire.parent.removeChild(btnReduire);
            }
            btnSoundOff.on("click", function() {
                mPlayer.muted = false;
            });
            btnSoundOn.on("click", function() {
                mPlayer.muted = true;
            });
            btnSoundOn.setRectHitArea(-2, -12, 22, 24);
            btnSoundOff.setRectHitArea(-2, -12, 22, 24);

            centerBtn.setRectHitArea(-10, -10, 20, 20);
            CenterBtn.call(centerBtn, slideshow);
            centerBtn.show();
        }

        init();
    }

    $g.BottomBar = BottomBar;

})(PVPGEngine, createjs, Modernizr, document, Math);
